// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"53b2c9fa","455":"3be85534"}[chunkId] + ".chunk.js";
};